import React from 'react';
import './css/Approach.css';
import chair from "../assets/1table2chair.png"
import { Link } from 'react-router-dom';
import svg1 from "../assets/approachsvg1.svg";
import svg2 from "../assets/approachsvg2.svg";
import svg3 from "../assets/approachsvg3.svg";

const Approach = () => {
    const data = [
        {
            img: svg1,
            heading: "Consult & Design",
            para: "We begin with understanding your vision, space, and requirements. Our expert craftsmen create detailed designs that blend functionality with timeless aesthetics."
        },
        {
            img: svg2,
            heading: "Craft & Build",
            para: "Using premium materials and traditional woodworking techniques, we meticulously craft each piece. Every detail is executed with precision and expertise."
        },
        {
            img: svg3,
            heading: "Perfect & Deliver",
            para: "We ensure flawless finishing and installation, transforming your space with our handcrafted wooden masterpieces that stand the test of time."
        }
    ]

    return (
        <section className="approach-container-main">
            <div className='approach-container-main-content1'>
                <div className='approach-container-main-content1-content1'>
                    <div className='approach-image-div'>
                        <img src={chair} alt="Dhiman Wood Works Craftsmanship"/>
                    </div>
                    <div className='approach-container-main-content1-content1-content1'>
                        <div className='text-div-approach'>
                            <h1 className='heading-small'>Our Crafting Process</h1>
                            <p className='paragraph'>At Dhiman Wood Works, we combine traditional woodworking expertise with modern techniques to create bespoke wooden installations that enhance your space.</p>
                        </div>
                        <Link to="/services" className='link-approach'>
                            <button className='button-89-2'>Explore Our Services</button>
                        </Link>
                    </div>
                </div>
                <div className='approach-container-main-content1-content2'>
                    {data.map((item, index) => (
                        <div
                            style={{
                                border: index == data.length - 1 && 'none'
                            }}
                            className='approach-container-main-content1-content2-content1'
                            key={index}
                        >
                            <div className='approach-container-main-content1-content2-content1-content1'>
                                <img src={item.img} alt={`${item.heading} process`}/>
                            </div>
                            <div className='approach-container-main-content1-content2-content1-content2'>
                                <h1 className='heading-small'>{item.heading}</h1>
                                <p className='paragraph'>{item.para}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Approach;
